export const Background = `<svg xmlns="http://www.w3.org/2000/svg" width="1080" height="88" viewBox="0 0 1080 88" fill="none">
<g filter="url(#filter0_n_15034_74231)">
<rect width="1080" height="88" rx="8" fill="#252525"/>
</g>
<defs>
<filter id="filter0_n_15034_74231" x="0" y="0" width="1080" height="88" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feTurbulence type="fractalNoise" baseFrequency="3.3333332538604736 3.3333332538604736" stitchTiles="stitch" numOctaves="3" result="noise" seed="7276"/>
<feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise"/>
<feComponentTransfer in="alphaNoise" result="coloredNoise1">
<feFuncA type="discrete" tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "/>
</feComponentTransfer>
<feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped"/>
<feFlood flood-color="rgba(0, 0, 0, 0.63)" result="color1Flood"/>
<feComposite operator="in" in2="noise1Clipped" in="color1Flood" result="color1"/>
<feMerge result="effect1_noise_15034_74231">
<feMergeNode in="shape"/>
<feMergeNode in="color1"/>
</feMerge>
</filter>
</defs>
</svg>
`
